import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Booking from "../pages/booking/page";
import Analyse from "../pages/analyse/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/booking",
    element: <Booking />,
  },
  {
    path: "/analyse",
    element: <Analyse />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
